import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Loader from "components/Loader";
import { PROJECT_MIS } from "configs/urls";
import { useAtom } from "jotai";
import React, { useEffect, useState } from "react";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { getApi } from "services/api";
import { projectIdStore, villageIdStore } from "store/store";

import FieldOfficerModal from "./FieldOfficerModal";
import axios from "axios";
import { USERS } from "configs/urls";
import { ROLES } from "configs/urls";
import { getJobs } from "constant/network";
import { API_BASE_URL } from "configs/constant";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  marginLeft: {
    marginLeft: 10,
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

const WiseDialog = (props) => {
  const classes = useStyles();
  const { onClose, open, dialogData } = props;

  const [modalOpen, setModalOpen] = useState();
  const [foId, setFoId] = useState();

  const [projects, setProjects] = useState([]);
  const [isRequesting, setIsRequesting] = useState(false);
  const [allVillages, setAllVillags] = useState([]);
  const [driverList, setDriverList] = useState([]);

  const [villageId, setVillageId] = useState("");
  const [userList, setUserList] = useState();
  const [params, setParams] = useState({
    page: 0,
    size: 1000,
    role: 4,
    active: 1,
  });
  const [selectedTeam, setTeamSelect] = useState();
  const [selectedDriver, setSelectedDriver] = useState();
  const [filteredDriverList, setFilteredDriverList] = useState([]);
  const [farmsList, setFarmsList] = useState([]);
  const [filterType, setFilterType] = useState(null);
  const [villageList, setVillageList] = useState([]);

  const [projectId] = useAtom(projectIdStore);
  const [_, setVillageidNow] = useAtom(villageIdStore);

  const [fixedEquipmentList, setFixedEquipmentList] = useState([
    {
      id: 2,
      name: "Rake",
      fixed: 1,
      active: 1,
      driver_id: "",
      equipment_id: 2,
      vehicle_id: "",
      equipmentType: 2,
    },
    {
      id: 3,
      name: "Cutter",
      fixed: 1,
      active: 1,
      driver_id: "",
      equipment_id: 3,
      vehicle_id: "",
      equipmentType: 3,
    },
    {
      id: 4,
      name: "Bailer",
      fixed: 1,
      active: 1,
      driver_id: "",
      equipment_id: 4,
      vehicle_id: "",
      equipmentType: 4,
    },
    {
      id: 1,
      name: "Trolley",
      fixed: 1,
      active: 1,
      driver_id: "",
      equipment_id: 1,
      vehicle_id: "",
      equipmentType: 1,
    },
    {
      id: 9,
      name: "Swatch",
      fixed: 0,
      active: 1,
      driver_id: "",
      equipment_id: 9,
      vehicle_id: "",
      equipmentType: 9,
    },
    {
      id: 8,
      name: "Conditioner",
      fixed: 0,
      active: 1,
      driver_id: "",
      equipment_id: 8,
      vehicle_id: "",
      equipmentType: 8,
    },
    {
      id: 39,
      name: "Uprooter",
      fixed: 0,
      active: 1,
      driver_id: "",
      equipment_id: 39,
      vehicle_id: "",
      equipmentType: 39,
    },
  ]);

  const getAllData = () => {
    const users = getApi(USERS, params);
    const roles = getApi(ROLES);
    axios
      .all([users, roles])
      .then((res) => {
        if (res[0] && res[0]?.data) {
          setDriverList(res[0].data);
        }

        if (res[1] && res[1]?.data) {
          res[1].data.unshift({
            id: "all",
            slug: "all",
            name: "All",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  const filterDriverList = () => {
    return driverList
      ?.filter((el) => {
        return el?.driver_type_id == selectedTeam;
      })
      ?.map((item) => {
        setFilteredDriverList((el) => [...el, item]);
      });
  };

  useEffect(() => {
    setFilteredDriverList([]);
    filterDriverList();
  }, [selectedTeam]);

  useEffect(() => {
    if (open) {
      getAllData();
    }
  }, [open]);

  const getAllJobs = async () => {
    await axios
      .get(
        `${API_BASE_URL}${getJobs}?user_id=${selectedDriver}&&status="readyToStart, inprocess, pending, completed"`
      )
      .then((res) => {
        return res?.data?.map((item) => {
          return item?.farmer?.farms?.map((items) => {
            setFarmsList((el) => [
              ...el,
              {
                name: item?.farmer?.name,
                items,
              },
            ]);
          });
        });
      })
      .catch((err) => {})
      .finally(() => {});
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleChange = (event) => {
    setVillageId(event.target.value);
    setVillageidNow(event.target.value);
  };

  useEffect(() => {
    if (open) {
      setIsRequesting(true);
      getApi(PROJECT_MIS)
        .then((res) => {
          res.data
            .filter((item) => item?.id == projectId)
            .map((items) => {
              setProjects(items);
            });
        })
        .catch((err) => {})
        .finally(() => {
          setIsRequesting(false);
        });
    }
  }, [open]); //eslint-disable-line

  useEffect(() => {
    if (selectedDriver) {
      setFarmsList([]);
      getAllJobs();
    }
  }, [selectedDriver]);

  const addAllVillages = () => {
    setAllVillags([]);
    return projects?.field_supervisors?.map((item) => {
      return item?.villages?.map((items) => {
        setAllVillags((el) => [...el, items]);
      });
    });
  };

  const filterAcToVillage = () => {
    return projects?.field_supervisors?.map((item) => {
      return item?.villages
        ?.filter((el) => el.village_id == villageId)
        ?.map((items) => {
          setUserList(items?.user_id);
        });
    });
  };

  useEffect(() => {
    if (open && projects) {
      addAllVillages();
      filterAcToVillage();
    }
  }, [projects, open, villageId]);

  const renderProject = () => (
    <TableContainer component={Paper}>
      {farmsList?.length === 0 &&
      !selectedTeam &&
      filterType === "FieldOfficer" ? (
        <>
          <Table
            className={classes.table}
            aria-label="caption table"
            id="table-to-xls"
          >
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Villages</TableCell>
                <TableCell>Projects Completed</TableCell>
                <TableCell>Username</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userList ? (
                <>
                  {projects?.field_supervisors
                    ?.filter((items) => {
                      return userList && items?.user_id == userList;
                    })
                    ?.map((item, idx) => {
                      return (
                        <TableRow
                          key={idx}
                          onClick={() => {
                            setModalOpen(true);
                            setFoId(item?.user_details?.id);
                          }}
                        >
                          <TableCell>{idx + 1}</TableCell>
                          <TableCell>{item?.user_details?.name}</TableCell>
                          <TableCell>
                            <>
                              {item?.villages?.length > 1
                                ? item?.villages?.[0]?.village?.name +
                                  " " +
                                  "+" +
                                  (item?.villages?.length - 1)
                                : item?.villages?.[0]?.village?.name}
                            </>
                          </TableCell>
                          <TableCell>{item?.project_completed}</TableCell>
                          <TableCell>{item?.user_details?.username}</TableCell>
                          <TableCell>{item?.user_details?.mobile_no}</TableCell>
                          <TableCell>
                            <Button
                              type="button"
                              color="primary"
                              variant="contained"
                              onClick={() => {
                                setModalOpen(true);
                                setFoId(item?.user_details?.id);
                              }}
                            >
                              View
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </>
              ) : (
                <>
                  {projects?.field_supervisors?.map((item, idx) => {
                    return (
                      <TableRow key={idx}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{item?.user_details?.name}</TableCell>
                        <TableCell>
                          {item?.villages?.length > 1
                            ? item?.villages?.[0]?.village?.name +
                              " " +
                              "+" +
                              (item?.villages?.length - 1)
                            : item?.villages?.[0]?.village?.name}
                        </TableCell>
                        <TableCell>{item?.project_completed}</TableCell>
                        <TableCell>{item?.user_details?.username}</TableCell>
                        <TableCell>
                          <Button
                            type="button"
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              setModalOpen(true);
                              setFoId(item?.user_details?.id);
                            }}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </>
              )}
            </TableBody>
          </Table>
        </>
      ) : (
        <>
          <Table
            className={classes.table}
            aria-label="caption table"
            id="table-to-xls"
          >
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Area</TableCell>
                <TableCell>Bails Created</TableCell>
                <TableCell>Bails Picked Up</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {farmsList?.map((item, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{item?.name}</TableCell>
                    <TableCell>{item?.items?.area}</TableCell>
                    <TableCell>{item?.items?.status?.bails_created}</TableCell>
                    <TableCell>
                      {item?.items?.status?.bails_picked_up}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </>
      )}
    </TableContainer>
  );

  return (
    <>
      <Dialog onClose={onClose} open={open} fullWidth maxWidth="lg">
        <Loader isLoading={isRequesting} />
        <DialogTitle style={{ backgroundColor: "#319069", color: "#fff" }}>
          {dialogData.projectName + " > " + "Field Officer"}
        </DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "10px",
              marginBottom: "10px",
              gap: "10px",
            }}
          >
            <FormControl
              variant="outlined"
              style={{ width: "100px", marginLeft: "10px" }}
            >
              <InputLabel id="demo-simple-select-label">Filter</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterType}
                label="Filter"
                onChange={(e) => {
                  setFilterType(e.target.value);
                }}
              >
                <MenuItem value="FieldOfficer">Field Officer</MenuItem>
                <MenuItem value="Driver">Driver</MenuItem>
              </Select>
            </FormControl>

            {filterType === "FieldOfficer" && (
              <FormControl
                variant="outlined"
                style={{ width: "100px", marginLeft: "10px" }}
              >
                <InputLabel id="demo-simple-select-label">Villages</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={villageId}
                  label="Age"
                  onChange={handleChange}
                >
                  {allVillages?.map((item) => {
                    return (
                      <MenuItem value={item?.village_id}>
                        {item?.village?.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
            {filterType === "Driver" && (
              <FormControl
                variant="outlined"
                style={{ width: "150px" }}
                className={`${classes.formControl}`}
              >
                <InputLabel id={"Select-Team"}>Driver Type</InputLabel>

                <Select
                  labelId={"Select-Team"}
                  id={"team-id"}
                  name="team_id"
                  label="Team"
                >
                  {fixedEquipmentList.map(
                    (
                      { name = "", id = 0, equipment_id: equipmentId = "" },
                      idx
                    ) => {
                      return (
                        <MenuItem
                          key={idx + "-" + name + "-" + id}
                          value={name}
                          onClick={() => {
                            setTeamSelect(id);
                          }}
                        >
                          {name} Team
                        </MenuItem>
                      );
                    }
                  )}
                </Select>
              </FormControl>
            )}
            {selectedTeam && (
              <FormControl
                variant="outlined"
                className={`${classes.formControl}`}
                style={{ width: "150px" }}
              >
                <InputLabel id={"Select-Team"}>Driver</InputLabel>

                <Select
                  labelId={"Select-Team"}
                  id={"team-id"}
                  // value={selectedTeam || ""}
                  // onChange={handleEquipment}
                  name="team_id"
                  label="Team"
                >
                  {filteredDriverList.map(
                    (
                      { name = "", id = 0, equipment_id: equipmentId = "" },
                      idx
                    ) => {
                      return (
                        <MenuItem
                          key={idx + "-" + name + "-" + id}
                          value={name}
                          onClick={() => {
                            setSelectedDriver(id);
                          }}
                        >
                          {name} Team
                        </MenuItem>
                      );
                    }
                  )}
                </Select>
              </FormControl>
            )}
            <Button
              style={{ marginLeft: "10px" }}
              onClick={() => {
                setVillageId("");
                setUserList();
                setVillageidNow(0);
                setTeamSelect();
                setSelectedDriver();
                setFilteredDriverList([]);
                setFarmsList([]);
                setFilterType(null);
              }}
            >
              Clear
            </Button>
          </div>
          <div style={{ marginRight: "10px" }}>
            <ReactHtmlTableToExcel
              id="test-table-xls-button"
              table="table-to-xls"
              filename="tablexls"
              sheet="tablexls"
              buttonText="Export Data"
            />
          </div>
        </div>
        <div>
          {projects &&
          filterType &&
          projects.field_supervisors &&
          projects.field_supervisors.length ? (
            renderProject()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No Project Found
            </Box>
          )}
        </div>
      </Dialog>
      <FieldOfficerModal
        modalOpen={modalOpen}
        handleClose={handleClose}
        foId={foId}
      />
    </>
  );
};

export default WiseDialog;
